import { LayoutMode } from '../../../components/layout-buttons/types';
import {
  ADD_PRODUCT_COLLETION_WITH_FITLERS_TO_HISTORY,
  SET_PRODUCT_COLLECTION_LAYOUT,
} from '../actions';
import {
  PRODUCT_COLLECTION_LAST_FILTERS,
  PRODUCT_COLLECTION_LAYOUT,
} from '../constants';

type State = {
  userSelectedLayout?: LayoutMode;
  /**
   * ProductCollection.stateToVariables for the last 5 product collections
   */
  lastFilters?: { id: string; state: any }[];
};

const MAX_PRODUCT_COLLECTION_HISTORY = 5;

export default (state: State | undefined = {}, action: any): State => {
  switch (action.type) {
    case 'ROUTE_LOADED': {
      return {
        ...state,
      };
    }

    case SET_PRODUCT_COLLECTION_LAYOUT:
      return {
        ...state,
        userSelectedLayout: action.layout,
      };

    case ADD_PRODUCT_COLLETION_WITH_FITLERS_TO_HISTORY: {
      const lastFilters = state?.lastFilters ?? [];
      const newFilter = { id: action.id, state: action.state };

      const newFilterIndex = lastFilters.findIndex(
        filter => filter.id === newFilter.id
      );

      // Last filters act like a queue, so we unshift new entries and pop the oldest (if there are more than the configured amount)

      if (newFilterIndex !== -1) {
        lastFilters.splice(newFilterIndex, 1);
        lastFilters.unshift(newFilter);
      } else {
        lastFilters.unshift(newFilter);
        // In case MAX_PRODUCT_COLLECTION_HISTORY was changed eg. from 7 to 5, we use this while loop to remove the oldest 2+1 entries
        while (lastFilters.length > MAX_PRODUCT_COLLECTION_HISTORY) {
          lastFilters.pop();
        }
      }

      return {
        ...state,
        lastFilters,
      };
    }

    case 'LOCAL_STORAGE_RECEIVE': {
      const productCollectionLayoutFromLocalStorage =
        action.localStorageState[PRODUCT_COLLECTION_LAYOUT];
      const lastFilters =
        action.localStorageState[PRODUCT_COLLECTION_LAST_FILTERS];

      return {
        ...state,
        userSelectedLayout:
          typeof productCollectionLayoutFromLocalStorage !== 'undefined' &&
          // Don't set `userSelectedLayout` if localStorage contains a faulty or removed value
          Object.values(LayoutMode).includes(
            productCollectionLayoutFromLocalStorage
          )
            ? productCollectionLayoutFromLocalStorage
            : undefined,
        lastFilters,
      };
    }
    default:
      break;
  }

  return state;
};
